export default __webpack_public_path__ + "static/media/icon_logistic.d446b1de.svg";